import {mergeMap, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {take} from 'rxjs/operators';
import {Auth, idToken} from '@angular/fire/auth';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private fireAuth: Auth) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return idToken(this.fireAuth).pipe(
            take(1),
            mergeMap(idToken => {
                const headers = req.headers
                    .set('Content-Type', 'application/json')
                    .set('Authorization', `Bearer ${idToken}`);
                return next.handle(req.clone({headers}));
            })
        );
    }

}
